import { Injectable } from '@angular/core';
import { APPCONFIG } from '../config';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MenuItem } from '../models/menu-item';
import { map } from 'rxjs/operators';
@Injectable({providedIn: 'root'})
export class MenuItemService {
  private readonly NAVBAR_KEY = 'navbarItems';
  private readonly ALL_ROUTER_LINKS_KEY = 'allMenuRouterLinks';
  private readonly ALL_ROUTER_LINKS_TTL_HOURS = 24;

  constructor(private http: HttpClient) {
  }

  getAllStructured(): Observable<MenuItem[]> {
    const storedMenuItems: MenuItensStored = this.getNavbarItems();
    if (storedMenuItems) {
      const expirationTime = new Date(storedMenuItems.expirationTime);
      if (expirationTime > new Date()) {
        return new Observable<MenuItem[]>((observer) => {
          observer.next(storedMenuItems.menuItems);
          observer.complete();
        });
      }
    }
    return this.http.get(APPCONFIG.apiHost + '/api-security/secure/menu/structure')
      .pipe(map((response: any) => {
        const newMenuStructure = response as MenuItem[];
        const expirationTime = new Date();
        expirationTime.setHours(expirationTime.getHours() + 12);
        this.setNavbarItems({menuItems: newMenuStructure, expirationTime: expirationTime});
        return newMenuStructure;
      }));
  }

  getAllStructuredByAplication(origin: any): Observable<MenuItem[]> {
    return this.http.get(APPCONFIG.apiHost + '/secure/menu/application-structure/' + origin).pipe(
      map((response: any) => response.data.menuItens as MenuItem[]));
  }

  findRouterLinkAccessByUser(): Observable<string[]> {
    return this.http.get(APPCONFIG.apiHost + '/api-security/secure/menu/structure/router-link-access')
      .pipe(map((response: any) => response as string[]));
  }

  findAllMenuRouterLinks(): Observable<string[]> {
    const cached = this.getCachedAllRouterLinks();
    if (cached) {
      return new Observable<string[]>((observer) => {
        observer.next(cached);
        observer.complete();
      });
    }
    return this.http.get(APPCONFIG.apiHost + '/api-security/secure/menu/structure/all-router-links')
      .pipe(map((response: any) => {
        const links = (response as string[]) || [];
        this.setCachedAllRouterLinks(links);
        return links;
      }));
  }

  private getCachedAllRouterLinks(): string[] | null {
    const raw = localStorage.getItem(this.ALL_ROUTER_LINKS_KEY);
    if (!raw) return null;
    try {
      const parsed = JSON.parse(raw) as { links: string[]; expirationTime: string };
      if (new Date(parsed.expirationTime) > new Date()) {
        return parsed.links;
      }
    } catch {
      return null;
    }
    return null;
  }

  private setCachedAllRouterLinks(links: string[]): void {
    const expirationTime = new Date();
    expirationTime.setHours(expirationTime.getHours() + this.ALL_ROUTER_LINKS_TTL_HOURS);
    localStorage.setItem(this.ALL_ROUTER_LINKS_KEY, JSON.stringify({ links, expirationTime }));
  }

  getNavbarItems(): MenuItensStored | null {
    const storedItems = localStorage.getItem(this.NAVBAR_KEY);
    return storedItems ? JSON.parse(storedItems) : null;
  }
  setNavbarItems(item: MenuItensStored): void {
    localStorage.setItem(this.NAVBAR_KEY, JSON.stringify(item));
  }
}

class MenuItensStored{
  menuItems: MenuItem[];
  expirationTime: Date;
}
